import { CalendarWeekDay } from "./CalendarWeekDay";


export class CalendarWeek {
  weekStart: string; 
  weekEnd: string;  
  days: CalendarWeekDay[];
  isFlexible:boolean

  constructor() {
    this.weekStart = '';
    this.weekEnd = '';
    this.days = [];
    this.isFlexible=false;
  }
}
